import './Filter.css';
import React, {useEffect, useRef, useState} from 'react';
import FilterProps from './filterProps/FilterProps';
import FilterTags from '../filterTags/FilterTags';

function Filter(props) {
  const sectionArr = [17901, 18700, 19017, 18227, 18432, 18900, 19018, 18891];
  const [selectedFiltersHeight, setSelectedFiltersHeight] = useState(0);
  const [isHeightCalculated, setIsHeightCalculated] = useState(false); // Новый флаг
  const filterClass = `lg:calc(100% - ${selectedFiltersHeight + 119}px) phone:lg:calc(100% - ${selectedFiltersHeight + 123}px)`

  useEffect(() => {
    if (!isHeightCalculated && selectedFiltersHeight > 0) {
      setIsHeightCalculated(true);
    }
  }, [selectedFiltersHeight]); // Этот эффект вызовется, когда высота обновится


  const title = props.messages &&
  props.messages.hasOwnProperty('CT_BCSF_FILTER_FILTERS') ?
      props.messages.CT_BCSF_FILTER_FILTERS : '';

  const show = props.messages &&
  props.messages.hasOwnProperty('CT_BCSF_FILTER_SHOW') ?
      props.messages.CT_BCSF_FILTER_SHOW : '';

  return (
    sectionArr.includes(props.params.SECTION_ID) ?
      <aside>
        <div className={`filter-section ${props.opened
          ? 'opened'
          : ''}`}>
          <form name="filter" action="/" method="post">
            {
              props.isMobile ?
                <>
                <span className="close-filter"
                      onClick={props.onClose}/>
                  <div className="filter-title">
                    <span>{title}</span>
                    {
                      props.selectedFiltersExist ?
                        <FilterTags {...props.filterTags}
                                    setSelectedFiltersHeight={setSelectedFiltersHeight}
                                    isMobile={props.isMobile}
                                    messages={props.messages}
                                    onPropChange={props.onChange}/> :
                        <></>
                    }
                  </div>
                </> :
                <></>
            }
            <div className={`filter__container ${isHeightCalculated && props.isMobile ? filterClass : ''}`}>
              <FilterProps items={props.filterItems}
                           isMobile={props.isMobile}
                           messages={props.messages}
                           onChange={props.onChange}
                           onPriceChange={props.onPriceChange}/>
            </div>
            {
              props.isMobile ?
                <div className="btn-show">
                  <span className="popup-result__title"
                        onClick={props.onClose}>
                    {`${show} ${props.totalProductsCount} ${props.totalProductsCountMessage}`}
                  </span>
                </div> :
                <></>
            }
          </form>
        </div>
      </aside> :
      <div className={`filter-section ${props.opened
        ? 'opened'
        : ''}`}>
        <form name="filter" action="/" method="post">
          {
            props.isMobile ?
              <>
                <span className="close-filter"
                      onClick={props.onClose}/>
                <div className="filter-title">
                  <span>{title}</span>
                  {
                    props.selectedFiltersExist ?
                      <FilterTags {...props.filterTags}
                                  setSelectedFiltersHeight={setSelectedFiltersHeight}
                                  isMobile={props.isMobile}
                                  messages={props.messages}
                                  onPropChange={props.onChange}/> :
                      <></>
                  }
                </div>
              </> :
              <></>
          }
          <div className={`filter__container ${isHeightCalculated && props.isMobile ? filterClass : ''}`}>
            <FilterProps items={props.filterItems}
                         isMobile={props.isMobile}
                         messages={props.messages}
                         onChange={props.onChange}
                         onPriceChange={props.onPriceChange}/>
          </div>
          {
            props.isMobile ?
              <div className="btn-show">
                  <span className="popup-result__title"
                        onClick={props.onClose}>
                    {`${show} ${props.totalProductsCount} ${props.totalProductsCountMessage}`}
                  </span>
              </div> :
              <></>
          }
        </form>
      </div>
  );
};

export default Filter;